<template>
  <div class="miya-resetPassword-page">
    <login-left></login-left>
    <div class="right-box">
      <div class="login-lang">
        <el-tooltip class="item" effect="dark" :content="$t('menu.backHome')" placement="bottom">
          <div class="btnBack" @click.stop="$router.push('/home')"></div>
        </el-tooltip>
        <miya-lang></miya-lang>
      </div>
      <reset-password ref="reset" @success="resetSuccess()">
        <template slot="title">
          <h1 class="title1 fontSH">{{$t('login.title3')}}</h1>
        </template>
        <template slot="btnCancel">         
          <div class="cancelReset" @click.stop="$router.push('/login')">{{$t('pTraffic.payCancel')}}</div> 
        </template>
      </reset-password>
    </div>
  </div>
</template>
<script>
import loginLeft from './loginLeft.vue'
import miyaLang from '@components/lang.vue'
import resetPassword from '@views/login/resetPasswordComponent.vue'
import {logout} from '@assets/js/http.js'
export default {
  data () {
    return {
    }
  },
  mounted () {  
  },
  methods: {
    resetSuccess () {
      this.$post(`/Check/Logout`).then(res => {
        if (res.code === 200) {
          logout()
        }        
      })
    },
  },
  beforeDestroy () {
  },
  components: {loginLeft, miyaLang, resetPassword}
}
</script>
<style scoped lang="stylus">
.miya-resetPassword-page
  display flex
  min-height 100vh
  .right-box
    flex 1
    padding-bottom 36px
    .login-lang
      padding-right 48px
      display flex
      line-height 72px
      justify-content right
      .btnBack
        cursor pointer
        width 20px
        margin 26px
        background-image url('../../assets/images/icon/home.svg')
        &:hover
          background-image url('../../assets/images/icon/home1.svg')
    .card
      width 40%
      min-width 450px
      margin 30px auto 0 auto
      color $c1
    .title1
      font-size 40px
      text-align center
      margin-bottom 56px
    .inputName
      font-size $f16
      margin 36px 0 12px 0
      fontWeight()
    .emailCode
      display flex
      .sendBtn
        margin-left 10px
        width 180px
        &:hover
          box-shadow: 0px 8px 15px 1px rgba(20,17,14,0.16)
          background-color $c1
      .is-disabled
        &:hover
          box-shadow none
          background-color $c3
    .tipString
      font-size $f14
      color $c2
      margin-top -16px
      margin-bottom 12px
    .password-box
      display flex
      .item
        flex 1
        &:last-child
          margin-left 24px
    .checkbox
      margin-top 32px
      display flex
    .checkText
      font-size 16px
      color $c1
      line-height 20px
      margin-left 8px
      .click
        color $c8
        cursor pointer
    .loginBtn
      line-height 54px
      text-align center
      letter-spacing 2px
      color $c7
      border-radius 2px
      font-size $f18
      margin 16px 0
      width 100%
      border none
      background: linear-gradient(88deg, #FF8F10 0%, #FF6F00 100%);
    .account
      display flex
      justify-content space-between
      color $c2
      margin-left 0
      .forgetPassword
        color $c1
        cursor pointer
  .cancelReset
    width 60px
    text-align center
    margin 0 auto
    color $c2
    cursor pointer
    font-size $f18
    letter-spacing 1px
    &:hover
      color $c1
@media screen and (max-width: 800px) 
  .miya-resetPassword-page
    display block
    .right-box
      position relative
      z-index 3
      width calc(100% - 2rem)
      margin 0 auto
      .login-lang
        color $c7
        padding-right 0
        .btnBack
          width 1.4rem
          height 1.4rem
          margin 1rem 1.5rem 0 0 
          background-size 100% 100%
      >>>.card
        width 100%
        min-width 320px
        background-color rgba(255,255,255,0.1)
        backdrop-filter blur(8px)
        border 1px solid rgba(255,255,255,0.2)
        border-radius 4px
        padding 1rem 1rem 0.8rem 1rem
        .title1
          color $c7
          font-size 1.2rem
          margin-bottom 1.5rem
      >>>.inputName
        color $c7
        font-size 0.7rem
      >>>.tipString
        color $c4
</style>
<style lang="stylus">
.miya-resetPassword-page
  .el-input-group__append, .el-input-group__prepend
    width 140px
    background-color #f5f5f5
    .is-disabled
      color $c4
  .el-form-item__error
    font-size 14px
  .el-input .el-input__clear
    font-size 16px
    color $c2
  .el-checkbox__inner
    width 20px
    height 20px
  .el-checkbox__inner::after
    width 6px
    height 12px
    left 5px
</style>